module.exports = __webpack_public_path__ + "static/media/resetPoints.beaaa9d2.webp";